class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.hoverMedia = window.matchMedia('(min-width: 990px)');

    if (this.megaMenu) {
      this.onHoverOpen = this.onHoverOpen.bind(this);
      this.onHoverClose = this.onHoverClose.bind(this);
      this.hoverMedia.addEventListener('change', this.onHoverMediaChange.bind(this));
      this.onHoverMediaChange();
    }
  }

  onHoverMediaChange() {
    if (!this.megaMenu) return;

    if (this.hoverMedia.matches) {
      this.addEventListener('mouseenter', this.onHoverOpen);
      this.addEventListener('mouseleave', this.onHoverClose);
    } else {
      this.removeEventListener('mouseenter', this.onHoverOpen);
      this.removeEventListener('mouseleave', this.onHoverClose);
    }
  }

  onHoverOpen() {
    if (!this.hoverMedia.matches) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onHoverClose() {
    if (!this.hoverMedia.matches) return;
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
